import { useEffect, useState } from 'react';
import api from '../services/api';

// Beta — qué funciones de IA están disponibles AHORA para la sesión
// (GET /api/capacidades-ia). Solo se usa para mostrar un aviso claro y desactivar la
// acción cuando el servidor dice EXPLÍCITAMENTE que una función está apagada. Si la
// consulta falla o la respuesta no tiene la forma esperada, el estado es
// 'desconocido' y la interfaz se comporta como siempre (el backend sigue gobernando
// cada llamada y responde con su propio mensaje). Una consulta por sesión (clave =
// token guardado): iniciar o cerrar sesión la vuelve a pedir.
const CLAVES = ['kiq_chat', 'recetas_texto', 'recetas_importacion', 'merma', 'facturas'];
const INICIAL = Object.freeze({ estado: 'cargando' });
const DESCONOCIDO = Object.freeze({ estado: 'desconocido' });
let cache = null;

export function reiniciarCapacidadesIA() { cache = null; }

function claveSesion() {
  try { return localStorage.getItem('riq_token') || ''; } catch { return ''; }
}

function cargar() {
  return Promise.resolve()
    .then(() => api.get('/api/capacidades-ia'))
    .then((r) => {
      const d = r?.data;
      if (!d || typeof d !== 'object' || Array.isArray(d) || !CLAVES.every((k) => typeof d[k] === 'boolean')) return DESCONOCIDO;
      return { estado: 'listo', ...Object.fromEntries(CLAVES.map((k) => [k, d[k]])) };
    })
    .catch(() => DESCONOCIDO);
}

// true solo si el servidor confirmó que la función está apagada para esta sesión.
export function iaNoDisponible(capacidades, clave) {
  return capacidades?.estado === 'listo' && capacidades[clave] !== true;
}

export function useCapacidadesIA() {
  const [capacidades, setCapacidades] = useState(() => (cache && cache.clave === claveSesion() && cache.valor) || INICIAL);
  useEffect(() => {
    let vivo = true;
    const clave = claveSesion();
    if (!cache || cache.clave !== clave) cache = { clave, promesa: cargar() };
    const actual = cache;
    actual.promesa.then((v) => { actual.valor = v; if (vivo) setCapacidades(v); });
    return () => { vivo = false; };
  }, []);
  return capacidades;
}
